<template>
  <div class="fx_user_dropdown" style="">

    <!-- <div v-if="$app.helper.screen.isPC" style="text-align:center;font-size:12px">
       {{$store.state.core.user.cnname}}
    </div> -->
    <core-avatar :size="40" :userid="$store.state.core.user.userid" :username="$store.state.core.user.cnname" title="" class="avatar" />

    <Dropdown class="user-menu" @on-click="onclick">
      <div class="username">
        {{$store.state.core.user.cnname}}
        <!--square-->
        <Icon size='15' type="ios-arrow-down" />
        <!-- <Icon size='15' type="ios-arrow-down" /> -->
      </div>

      <DropdownMenu slot="list" style="text-align:center">
        <DropdownItem name="accountSetting">修改密码</DropdownItem>
        <DropdownItem name="userOptions">个人设定</DropdownItem>
        <DropdownItem name="logout">安全退出</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <!-- <changePWD title="修改密码" :show="modalASetting" :closable="true" @on-cancel="cancel" /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalASetting: false,
    }
  },
  methods: {
    onclick(name) {
      if (name === "logout") {
        this.$app.safelogout()
        // this.$store.dispatch("core/logout");
        // this.$curl.post("/api/core/logout").then(() => {
        //   location.href = "login.html";
        // });
      } else if (name == "userOptions") {
        // this.$store.commit("core/setUserOptions", true);
        this.$router.push({ name: "core-personalSetting", params: { key: "null" } })
      } else if (name == "accountSetting") {
        // this.$router.push({ name: "core-accountSetting" });
        this.$router.push({ name: "core-personalSetting", params: { key: "securitySetting" } })
        //this.modalASetting = true;
      }
    },
    cancel() {
      this.modalASetting = false
    },
  },
  mounted() {
    // this.cnname = this.$store.state.core.user.cnname
  },
}
</script>
<style lang="scss">
.fx_user_dropdown {
  display: flex;
  align-items: center;
  justify-content: center;

  .avatar {
    margin-right: 8px;
  }

  .username {
    display: flex;
    align-items: center;
    margin-right: 8px;
    // color: rgba(255,255,255,.7);
    cursor: pointer;
  }
}
</style>

